import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import { RootState } from '@/store/types';
import { application } from '@/store/application';
import { arbeitsplaetze } from '@/store/arbeitsplaetze';
import { authentication } from '@/store/authentication';
import { briefarten } from '@/store/briefarten';
import { cards } from '@/store/cards';
import { elgauebertragung } from '@/store/elgauebertragung';
import { emails } from '@/store/emails';
import { globals } from '@/store/globals';
import { grids } from '@/store/grids';
import { impfdb } from '@/store/impfdb';
import { impfempfehlungen } from '@/store/impfempfehlungen';
import { impferinnerungen } from '@/store/impferinnerungen';
import { zahlungserinnerungen } from '@/store/zahlungserinnerungen';
import { impferinnerungstexte } from '@/store/impferinnerungstexte';
import { impfstoff } from '@/store/impfstoff';
import { impfstoffe } from '@/store/impfstoffe';
import { kassafuehrung } from '@/store/kassafuehrung';
import { laender } from '@/store/laender';
import { lagerfuehrung } from '@/store/lagerfuehrung';
import { leistungen } from '@/store/leistungen';
import { logbuch } from '@/store/logbuch';
import { logs } from '@/store/logs';
import { patient } from '@/store/patient';
import { patientenauswertung } from '@/store/patientenauswertung';
import { personen } from '@/store/personen';
import { reise } from '@/store/reise';
import { reisearten } from '@/store/reisearten';
import { reiseziele } from '@/store/reiseziele';
import { replaceStateReactiveCheckPlugin } from '@/store/reactiveCheck';
import { rezepte } from '@/store/rezepte';
import { session } from '@/store/session';
import { statistik } from '@/store/statistik';
import { systemdaten } from '@/store/systemdaten';
import { terminarten } from '@/store/terminarten';
import { terminkalender } from '@/store/terminkalender';
import {terminplaetze} from '@/store/terminplaetze';
import { texte } from '@/store/texte';
import { titel } from '@/store/titel';
import { untersuchungen } from '@/store/untersuchungen';
import { users } from '@/store/users';
import { versicherungen } from '@/store/versicherungen';
import { warteliste } from '@/store/warteliste';
import { zahlungsarten } from '@/store/zahlungsarten';
import { anforderungen } from '@/store/anforderungen';
import { dienstorte } from '@/store/dienstorte';
import { patientengruppen } from '@/store/patientengruppen';
import { studien } from '@/store/studien';
import { impfaktionen } from '@/store/impfaktionen';
import { diagnosen } from '@/store/diagnosen';
import { impfsettings } from './impfsettings';

Vue.use(Vuex);

const store = new Vuex.Store<RootState>({
    modules: {
        application,
        arbeitsplaetze,
        authentication,
        briefarten,
        cards,
        elgauebertragung,
        emails,
        globals,
        grids,
        impfdb,
        impfempfehlungen,
        impferinnerungen,
        zahlungserinnerungen,
        impferinnerungstexte,
        impfstoff,
        impfstoffe,
        impfsettings,
        kassafuehrung,
        laender,
        lagerfuehrung,
        leistungen,
        logbuch,
        logs,
        patient,
        patientenauswertung,
        personen,
        reise,
        reisearten,
        reiseziele,
        rezepte,
        session,
        statistik,
        systemdaten,
        terminarten,
        terminkalender,
        texte,
        titel,
        untersuchungen,
        users,
        versicherungen,
        warteliste,
        zahlungsarten,
        anforderungen,
        dienstorte,
        patientengruppen,
        impfaktionen,
        studien,
        diagnosen,
        terminplaetze
    },
    plugins: [
        replaceStateReactiveCheckPlugin,
        (new VuexPersistence({
            modules: ['grids', 'session', 'arbeitsplaetze'],
        })).plugin,
    ],
});

export default store;
